<div class="e-header">
  <div class="container">
    <div class="e-text">
      <h1>
        <span i18n class="e--light">Die Domain</span>
        <span fitText [wrap]="true">{{ context.config.name }}</span>
        <span i18n class="e--light">steht zum Verkauf</span>
      </h1>
    </div>

    <div class="e-box">
      <a class="e-main-logo" [href]="context.links.promo_index|userToken">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4657 687">
          <path class="e-surface"
                d="M1390.64,467v26.57H1185.16V203h199.25v26.57H1215.87V332.89h116.58V359H1215.87V467Zm72.22-264h30.72V467H1656.3v26.57H1462.86Zm244.5,0h30.71V493.54h-30.71Zm181.81,26.57H1787.05V203h235v26.57H1919.89v264h-30.72ZM2276.46,467v26.57H2071V203h199.26v26.57H2101.7V332.89h116.58V359H2101.7V467Zm386-118.72c0-85.93,66.42-149.44,156.5-149.44s156.5,63.1,156.5,149.44S2909.08,497.69,2819,497.69,2662.5,434.18,2662.5,348.25Zm258.62,0c0-59.36-43.59-102.12-102.12-102.12s-102.12,42.76-102.12,102.12S2760.47,450.37,2819,450.37,2921.12,407.61,2921.12,348.25Zm362,145.29-.42-192.61-95.47,159.4h-24.08l-95.48-156.91V493.54h-51.47V203h44.42L3176,395.57,3289.32,203h44.42l.41,290.58ZM3723.51,203h54V493.54h-54Zm390.62,0V493.54h-44.42L3909.48,296.78V493.54h-53.55V203h44.42l160.23,196.76V203Zm53.54,259.86,18.68-41.93c23.25,18.69,60.19,32,95.9,32,45.24,0,64.34-16.19,64.34-37.78,0-62.68-172.69-21.58-172.69-129.51,0-46.91,37.36-86.76,117.06-86.76,34.87,0,71.4,9.13,96.72,25.73l-17,41.93c-26.15-15.36-54.79-22.83-80.11-22.83-44.83,0-63.1,17.44-63.1,39.44,0,61.85,172.27,21.58,172.27,128.27,0,46.49-37.77,86.34-117.47,86.34C4237,497.69,4191.75,483.58,4167.67,462.82ZM3555.4,203h-53.14L3371.5,493.54h55.63l10-23.53H3437l4.26-9.65,14.51-34.08L3474,384l54.38-127,42.84,99.3h.21L3581.53,380l1.68,3.91h0l18.09,42.82,28.85,66.77h56.46Zm-1088,0h-127v217.9h54V248.62h70.57c64.76,0,106.68,39.44,106.68,99.63s-41.92,99.63-106.68,99.63H2421.1v45.66h46.31c94.23,0,158.57-58.11,158.57-145.29S2561.64,203,2467.41,203Z"></path>
          <path class="e-surface"
                d="M3.39,0V687h925V0ZM158.08,309.43H332.34v68.08H158.08Zm276.39,238.3H158.08V479.64H434.47Zm136.17,0V479.64c75.45,0,136.83-61.47,136.83-136.92S646.09,207.3,570.64,207.3H502.56V411.56H434.47V207.3H158.25V139.21H570.64c112.25,0,203.58,91.25,203.58,203.51S682.89,547.73,570.64,547.73Z"></path>
        </svg>
      </a>

      @if (context.config.price) {
        <div class="e-price-box">
          <app-price [amount]="context.config.price"/>

          <div class="e-tax-note">
            <div class="e-tax-label" i18n>ohne MwSt.</div>
            <app-icon class="e--info" (click)="openPopup()">info_outline</app-icon>
          </div>
        </div>
      }

      <app-paynow-buy-buttons [context]="context"/>
      <app-payment-methods/>

      <ul class="e-liste-usps">
        <li>
          <app-icon class="e--check">check</app-icon>
          <span i18n>Sichere Zahlung mit Käuferschutz</span>
          <app-icon class="e--info" (click)="openInfos()">info_outline</app-icon>
        </li>
        <li>
          <app-icon class="e--check">check</app-icon>
          <span i18n>Automatische Rechnung per Mail</span>
          <app-icon class="e--info" (click)="openInfos()">info_outline</app-icon>
        </li>
        <li>
          <app-icon class="e--check">check</app-icon>
          <span i18n>Einfache Übertragung in Echtzeit</span>
          <app-icon class="e--info" (click)="openInfos()">info_outline</app-icon>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="e-body">
  <div class="container">
    <div class="e-content">
      <h2 i18n fitText [wrap]="true">Jetzt {{ context.config.name }} kaufen!</h2>

      <div class="grid">
        <div class="cell s12 l4">
          <div class="e-panel e--step">
            <div class="e-panel-head">
              <app-icon>shopping_cart</app-icon>
              <span>1.</span>
            </div>
            <div class="e-panel-body" i18n>
              Sie kaufen die Domain
            </div>
          </div>
        </div>
        <div class="cell s12 l4">
          <div class="e-panel e--step">
            <div class="e-panel-head">
              <app-icon>arrow_forward</app-icon>
              <span>2.</span>
            </div>
            <div class="e-panel-body" i18n>
              Übertragung zu Ihnen
            </div>
          </div>
        </div>
        <div class="cell s12 l4">
          <div class="e-panel e--step">
            <div class="e-panel-head">
              <app-icon>paid</app-icon>
              <span>3.</span>
            </div>
            <div class="e-panel-body" i18n>
              Auszahlung an Verkäufer
            </div>
          </div>
        </div>

        @if (context.config.template_data.image) {
          <div class="cell s12">
            <div
              class="e-panel e--image"
              [ngStyle]="{'background-image': 'url(' + context.config.template_data.image + ')'}"
            ></div>
          </div>
        }

        @if (context.config.template_data['individual-content--text']) {
          <div class="cell s12">
            <div class="e-panel e--content">
              <h3 class="e-panel-headline" fitText [wrap]="true">
                @if (context.config.template_data['individual-content--headline']) {
                  {{ context.config.template_data['individual-content--headline'] }}
                } @else {
                  <ng-container i18n>Text des Inhabers</ng-container>
                }
                <app-tooltip i18n>
                  Dies ist ein individueller Text des Domaininhabers, der möglicherweise nicht in Ihrer Sprache verfügbar ist.
                </app-tooltip>
              </h3>
              <div class="e-panel-body" [innerHTML]="context.config.template_data['individual-content--text']"></div>
            </div>
          </div>
        }

        @if (showArguments) {
          <div class="cell s12">
            <div class="e-panel e--highlight">
              <h3 class="e-panel-headline" i18n>
                Wieso sollte ich {{ context.config.name }} kaufen?
              </h3>
              <div class="e-panel-body" i18n>
                Diese Premium Domain ist bereits registriert und wird über ELITEDOMAINS exklusiv zum Verkauf
                angeboten. Gute Domains sind für erfolgreiche Internetprojekte entscheidend. Eine hochwertige Domain
                wirkt professioneller für Kunden, eine einprägsame Domain erzeugt besseres Marketing und eine eigene
                Domain macht unabhängig gegenüber Tech-Giganten. <br><strong>Wer zuerst zuschlägt, erhält
                diese Domain!</strong>
              </div>
            </div>
          </div>
        }

        @if (showReviews) {
          <div class="cell s12">
            <div class="e-panel e--reviews">
              <div class="swiper" #swiper>
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="e-review">
                      <div class="e-quote" i18n>
                        "Ich bin total begeistert: Der Kauf war einfach, ich habe den AuthCode für die Domain sofort
                        erhalten und konnte direkt loslegen. Sehr zu empfehlen!"
                      </div>
                      <div class="e-stars">
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                      </div>
                      <div class="e-name" i18n>Georg Wagner</div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="e-review">
                      <div class="e-quote" i18n>
                        "Der beste Support der Welt :) Freundlich, hilfsbereit und viel Fachwissen. Gerne wieder ..."
                      </div>
                      <div class="e-stars">
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                      </div>
                      <div class="e-name" i18n>Sabine Salzhammer</div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="e-review">
                      <div class="e-quote" i18n>
                        "Endlich eine faire Lösung für den Domainverkauf. Sieht alles sehr einfach und gut aus und ist
                        preislich echt Top!"
                      </div>
                      <div class="e-stars">
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                        <app-icon>star</app-icon>
                      </div>
                      <div class="e-name" i18n>Sergej Ivanov</div>
                    </div>
                  </div>
                </div>

                <div class="swiper-foot">
                  <div class="swiper-pagination"></div>
                  <div class="swiper-arrows">
                    <div class="swiper-arrow swiper-arrow-prev">
                      <app-icon>keyboard_arrow_left</app-icon>
                    </div>
                    <div class="swiper-arrow swiper-arrow-next">
                      <app-icon>keyboard_arrow_right</app-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="e-footer">
  <div class="e-foot">
    <div class="container">
      <a class="e-main-logo" [href]="context.links.promo_index|userToken">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4657 687">
          <path
            class="e-surface"
            d="M1390.64,467v26.57H1185.16V203h199.25v26.57H1215.87V332.89h116.58V359H1215.87V467Zm72.22-264h30.72V467H1656.3v26.57H1462.86Zm244.5,0h30.71V493.54h-30.71Zm181.81,26.57H1787.05V203h235v26.57H1919.89v264h-30.72ZM2276.46,467v26.57H2071V203h199.26v26.57H2101.7V332.89h116.58V359H2101.7V467Zm386-118.72c0-85.93,66.42-149.44,156.5-149.44s156.5,63.1,156.5,149.44S2909.08,497.69,2819,497.69,2662.5,434.18,2662.5,348.25Zm258.62,0c0-59.36-43.59-102.12-102.12-102.12s-102.12,42.76-102.12,102.12S2760.47,450.37,2819,450.37,2921.12,407.61,2921.12,348.25Zm362,145.29-.42-192.61-95.47,159.4h-24.08l-95.48-156.91V493.54h-51.47V203h44.42L3176,395.57,3289.32,203h44.42l.41,290.58ZM3723.51,203h54V493.54h-54Zm390.62,0V493.54h-44.42L3909.48,296.78V493.54h-53.55V203h44.42l160.23,196.76V203Zm53.54,259.86,18.68-41.93c23.25,18.69,60.19,32,95.9,32,45.24,0,64.34-16.19,64.34-37.78,0-62.68-172.69-21.58-172.69-129.51,0-46.91,37.36-86.76,117.06-86.76,34.87,0,71.4,9.13,96.72,25.73l-17,41.93c-26.15-15.36-54.79-22.83-80.11-22.83-44.83,0-63.1,17.44-63.1,39.44,0,61.85,172.27,21.58,172.27,128.27,0,46.49-37.77,86.34-117.47,86.34C4237,497.69,4191.75,483.58,4167.67,462.82ZM3555.4,203h-53.14L3371.5,493.54h55.63l10-23.53H3437l4.26-9.65,14.51-34.08L3474,384l54.38-127,42.84,99.3h.21L3581.53,380l1.68,3.91h0l18.09,42.82,28.85,66.77h56.46Zm-1088,0h-127v217.9h54V248.62h70.57c64.76,0,106.68,39.44,106.68,99.63s-41.92,99.63-106.68,99.63H2421.1v45.66h46.31c94.23,0,158.57-58.11,158.57-145.29S2561.64,203,2467.41,203Z"
          ></path>
          <path
            class="e-surface"
            d="M3.39,0V687h925V0ZM158.08,309.43H332.34v68.08H158.08Zm276.39,238.3H158.08V479.64H434.47Zm136.17,0V479.64c75.45,0,136.83-61.47,136.83-136.92S646.09,207.3,570.64,207.3H502.56V411.56H434.47V207.3H158.25V139.21H570.64c112.25,0,203.58,91.25,203.58,203.51S682.89,547.73,570.64,547.73Z"
          ></path>
        </svg>
      </a>

      <ul class="e-links">
        <li><a [href]="context.links.privacy|userToken" target="_blank" i18n>Datenschutz</a></li>
        <li><a [routerLink]="['/impressum']" rel="nofollow" target="_blank" i18n>Impressum</a></li>
      </ul>

      <app-i18n-selector/>

      <p class="e-slogan" i18n>
        <a [href]="context.links.provider|userToken" target="_blank">Domains günstig registrieren</a>,
        einfach verwalten und
        <a [href]="context.links.promo_sell_domains|userToken" target="_blank">Domains verkaufen</a>
        auf dem <a [href]="context.links.marketplace|userToken|safe" target="_blank">Domain Marktplatz</a>.
      </p>

      <p i18n>
        &copy; ELITEDOMAINS GmbH. <br>
        Alle Rechte vorbehalten
      </p>
    </div>
  </div>
</div>
